import { g_cns } from "global/common/cns";
import { _sectionProps } from "global/components/props/propsShown";
import { useContext } from "react";
import { gEnums } from "../../../enums/globalEnums";
import { getSectionThemeColors, setItemStyleAndClass } from "../../../styles/formatting";
import { sectionMerge } from "../../../viewSettings/helpers/sectionMerge";
import { settingsHelpers } from "../../../viewSettings/helpers/settingsHelpers";
import { FilterContext } from "../FilterContext";
import { FrameworkContext } from "../FrameworkContent";
import { PageAreaContext } from "../PageAreaContext";
import { ParentContext } from "../ParentContext";

export const useViewItemSettings = ({ viewItem, propGroups, itemData, _display, _propsToggled }) => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state, appSettings_state, currentSettings_state } = states
  const { pathViews, viewKey } = paps_state ?? {}
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUser_fns } = fns ?? {}
  const { appAccess, display: display_global } = aps_global ?? {}
  const { appAccessType } = appAccess ?? {}

  const { propOverrideOn } = appSettings_state ?? {}

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { desktopMode } = framework_state ?? {}

  // pageAreaContext
  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageViewItemKeys } = pageArea_state ?? {}

  const filterContext = useContext(FilterContext);
  const { uiFilter_state } = filterContext ?? {}
  const { groupDataProps } = uiFilter_state ?? {}
  let { selectedTab } = uiFilter_state ?? {}

  const { propArrays } = propGroups ?? {}

  const { hideSelectedPropsAndSections } = display_global ?? {}

  const { props: props_viewItem, propSections, display, desktopDisplay, itemColor, drillDown } = viewItem ?? {}
  const _display_vi = _display ? _display : display
  let _display_actual = desktopMode && desktopDisplay ? desktopDisplay : _display_vi

  const { colors } = itemColor ?? {}

  const styleAndClassB = {}
  if (colors) { setItemStyleAndClass(aps_global, styleAndClassB, colors) }
  styleAndClassB.className = g_cns.item_content //+ ' ' + uivi

  if (groupDataProps && groupDataProps.defaultTab && !selectedTab) { selectedTab = groupDataProps.defaultTab }

  // appAccessType, pathViews, props_viewItem, display, viewKey
  appUser_fns.validateAccess_props(appAccessType, pathViews, props_viewItem, _display_actual, viewKey, propOverrideOn, _propsToggled)
  appUser_fns.validateAccess_sections(pathViews, propSections, drillDown, null, _display_actual, appAccessType, viewKey, propOverrideOn)

  if (hideSelectedPropsAndSections && !propOverrideOn) {
    excludePropSections(props_viewItem, propSections)
  }

  const propSections_allowed = settingsHelpers.getPropSectionsGrouped(
    {
      aps_appUserSettings,
      display_global,
      itemData,
      propGroups,
      propOverrideOn,
      props_viewItem,
      propSections,
      viewItem,
    }
  )

  if (propSections_allowed) {
    _.forEach(propSections_allowed, (propSection_allowed, psKey) => {
      const { _allowSection } = propSection_allowed
      if (!_allowSection) {
        delete propSections_allowed[psKey]
      } else {
        switch (_allowSection) {
          case gEnums.viewPermissionTypes.deny:
            delete propSections_allowed[psKey]
            break;
          default:
            const { props: props_section_allowed } = propSection_allowed ?? {}
            ammendSectionStyles(aps_global, propSection_allowed)
            propSection_allowed._props_allowed = getUiAllowedProps(psKey, viewItem, props_section_allowed, desktopMode, null, propArrays, pageViewItemKeys, propOverrideOn)

        }
      }

    })
  }

  return { propSections_allowed, styleAndClassB }
}

const getUiAllowedProps = (psKey, viewItem, props_viewItem, desktopMode, ddGroupIndex, propArrays, pageViewItemKeys, propOverrideOn) => {

  const { display, desktopDisplay, key: key_viewItem } = viewItem
  const _display = desktopMode && desktopDisplay ? desktopDisplay : display
  const { ignoreTaggedProps, cardDisplayType } = _display ?? {}

  const currentAllowedProps = {}

  // get the props that are allowed
  if (props_viewItem) {

    let index = 0

    _.forEach(props_viewItem, (prop_viewItem, key) => {

      const { _allowProp, propType, display: display_prop, data, show } = prop_viewItem ?? {}
      let { prop: prop_key } = prop_viewItem ?? {}
      let { elemPropType } = display_prop ?? {}

      switch (_allowProp) {
        case gEnums.viewPermissionTypes.allow:
        case gEnums.viewPermissionTypes.allowOverride:
          let _allowUiProp = true

          let { eventKey } = data ?? {}

          // set defaults if not there
          if (!elemPropType && propType) { elemPropType = propType }
          if (!prop_key) { prop_key = prop_viewItem.key }
          if (eventKey && (prop_key !== eventKey)) { prop_key = eventKey }

          const { allowed } = checkAllowed(prop_viewItem, psKey, key, key_viewItem, prop_key, index, _sectionProps, ignoreTaggedProps, propArrays, pageViewItemKeys, cardDisplayType)

          if (!allowed) {
            _allowUiProp = false
          }

          if (_allowUiProp || propOverrideOn) {
            currentAllowedProps[prop_key] = prop_viewItem
            currentAllowedProps[prop_key]._show = show
          }
          break;
        default:

      }

      // if (_allowProp && show) {

      //   let _allowUiProp = true

      //   let { eventKey } = data ?? {}

      //   // set defaults if not there
      //   if (!elemPropType && propType) { elemPropType = propType }
      //   if (!prop_key) { prop_key = prop_viewItem.key }
      //   if (eventKey && (prop_key !== eventKey)) { prop_key = eventKey }

      //   const { allowed } = checkAllowed(psKey, key, key_viewItem, prop_key, index, _sectionProps, ignoreTaggedProps, propArrays, pageViewItemKeys, cardDisplayType)

      //   if (!allowed) {
      //     _allowUiProp = false
      //   }

      //   if (_allowUiProp || propOverrideOn) {
      //     currentAllowedProps[prop_key] = prop_viewItem
      //     currentAllowedProps[prop_key]._show = show
      //   }
      // }
      index++
    })
  }
  return currentAllowedProps

}

const ammendSectionStyles = (aps_global, propSection_allowed) => {

  const { key: key_propSection } = propSection_allowed ?? {}
  const { display: display_global } = aps_global ?? {}
  const { propsToSeparate: propsToSeparate_global } = display_global ?? {}

  const { sectionBody, sectionDisplay, sectionHeader } = sectionMerge(aps_global, propSection_allowed)
  const sectionBodyStyle = getSectionThemeColors(aps_global, sectionBody)

  let { bodyDisplayType } = sectionBody ?? {}
  let { sectionDisplayType } = sectionDisplay ?? {}

  switch (bodyDisplayType) {
    case gEnums.contentTypes.header:
      sectionBody.bodyDisplayType = gEnums.sectionBodyTypes.inline
      sectionHeader.headerDisplayType = gEnums.sectionHeaderTypes.none
      break;
    default:
    // nothing
  }

  let isSeparate;

  if ((sectionDisplayType === gEnums.sectionDisplayTypes.description) || (propsToSeparate_global && propsToSeparate_global.includes(key_propSection))) { isSeparate = true }
  if ((sectionDisplayType === gEnums.sectionDisplayTypes.bio) || (propsToSeparate_global && propsToSeparate_global.includes(key_propSection))) { isSeparate = true }

  if (isSeparate) {
    sectionHeader.headerDisplayType = gEnums.sectionHeaderTypes.none
    sectionBody.bodyDisplayType = gEnums.sectionBodyTypes.noCaptions
  }

  propSection_allowed._styles = {
    sectionBody,
    sectionBodyStyle,
    sectionHeader,
    sectionDisplay,
  }
}

const excludePropSections = (props_viewItem, propSections) => {
  const items = {
    tagged: _.filter(props_viewItem, { [gEnums.menuItemOptionTypes.tagged]: true }),
    schedule: _.filter(props_viewItem, { [gEnums.menuItemOptionTypes.schedule]: true }),
  }
  _.forEach(items, (item) => {
    _.forEach(item, (itemItem) => {
      const { propSection } = itemItem
      if (propSections && propSections[propSection]) {
        propSections[propSection]._allowSection = gEnums.viewPermissionTypes.deny
      }
    })
  })
}

const checkAllowed = (prop_viewItem, psKey, key, key_viewItem, prop_key, index, sectionProps, ignoreTaggedProps, propArrays, pageViewItemKeys, cardDisplayType) => {

  let allowed = true
  let reason = ''

  if (prop_key.indexOf('UTC') >= 0) {
    allowed = false
    reason = 'UTC'
  }

  if (sectionProps.hidden.includes(key)) {
    allowed = false
    reason = 'In Section Props'
  }
  if (psKey === 'schedule') {
    switch (cardDisplayType) {
      case gEnums.cardDisplayTypes.schedule:
      case gEnums.cardDisplayTypes.schedulePlus:
        if (sectionProps.schedule.includes(key)) {
          allowed = false
          reason = 'schedule'
        }
        break;
      default:
      // nothing
    }
  }

  if (index > 0) {
    if (ignoreTaggedProps && propArrays && propArrays.includes(prop_key)) {
      allowed = false
      reason = 'ignoreTaggedProps'
    }
    if (pageViewItemKeys && pageViewItemKeys.includes(key) && key_viewItem !== key) {
      allowed = false
      reason = 'pageViewItemKeys'
    }
  }

  if (prop_viewItem?.pin) {
    allowed = true
  }

  return { allowed, reason }

}